import React from "react";

function Footer() {
  return (
    <div>
      <footer className="bg-fuchsia-950 p-4 text-center text-xs text-white w-screen mt-auto">
        <p>&copy; 2024 Recommendations Tracker created by Afsha with ❤️</p>
      </footer>
    </div>
  );
}

export default Footer;
